import {BoundProductInfo} from '../sdk/sdk';

export function aggregateBoundProducts(products: BoundProductInfo[]): BoundProductInfo[] {
  if (products.length === 0) return [];

  const groups = new Map<string, BoundProductInfo[]>();
  for (const p of products) {
    const productKey = p.productId ?? p.id;
    const noteKey = p.note?.trim() || '';
    const key = `${productKey}::${noteKey}`;
    const group = groups.get(key);
    if (group) group.push(p);
    else groups.set(key, [p]);
  }

  const result: BoundProductInfo[] = [];
  for (const group of groups.values()) {
    const totalQuantity = group.reduce((sum, p) => sum + (p.quantity ?? 0), 0);
    if (totalQuantity === 0) continue;
    if (totalQuantity < 0) {
      console.warn(
        `aggregateBoundProducts: product group "${group[0].productInfo?.name ?? group[0].productId}" ` +
        `has negative aggregated quantity (${totalQuantity}). This may indicate a data integrity issue.`
      );
    }

    const base = group.find(p => !p.changeOrderId) ?? group[0];

    // The `id` is inherited from the base entry and identifies the original bound-product row.
    // It should not be used for mutations on aggregated rows since it does not represent the full group.
    result.push(new BoundProductInfo({
      ...base,
      quantity: totalQuantity,
      grossAmount: group.reduce((sum, p) => sum + (p.grossAmount ?? 0), 0),
      netAmount: group.reduce((sum, p) => sum + (p.netAmount ?? 0), 0),
      note: base.note,
      changeOrderId: undefined,
    }));
  }

  return result;
}
